import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Message } from 'primeng/api';
import { CommonBindingDataService } from './../../services/common-binding-data.service';

@Component({
  selector: 'app-notification-mg1',
  templateUrl: './notification-mg1.component.html'
})

export class NotificationMG1Component implements OnInit {
  @Input() notifications;
  @Input() notificationCount;
  @Output() loadMoreNotification: EventEmitter<any> = new EventEmitter();
  @Input() showMoreOff = false;
  message: Message[] = [];
  labelLoadMore = '';

  constructor(private commonBindingDataService: CommonBindingDataService) { }

  ngOnInit() {
    this.labelLoadMore = this.commonBindingDataService.getLabel('label_load_more_notifications');
  }

  onLoadMore() {
    this.loadMoreNotification.emit();
  }

}
